export const amountedExtraOptionCodes = [
  "azt",
  "spaxschroeven",
  "kelfortplaatschroef",
  "plaatschroef42x13",
  "plaatschroef4.2x19",
  "fisherplug",
  "tapevhb1mm",
  "uitrubber12mm",
  "vastrubber12mmglas12mtr",
  "vastrubber10mmglas12mtr",
  "witglaswig185x1",
  "blauwglaswig185x2",
  "roodglaswig185x3",
  "groenglaswig185x5",
  "25mcelband",
  "37mcelband",
  "75mcelband",
];
